<app-navbar></app-navbar>
<section>
  <div class="container">
    <div class="row">
      <div class='card m-5'>
        <div class='card-body'>
          <div class="col-md-12">
            <h1 class="custom-title mt-3">Principal's Message</h1>
            <div class="custom-image">
              <img src="assets/img/school/messages/4.jpg" alt="Image" class="img-fluid" style="max-width: 100%;">
            </div>
            <div class="custom-text mt-3">
              <p>Proyash-Chattogram commenced her journey as an institute for children with special needs under the
                auspices of the
                Bangladesh Army in 2006. Children with special needs can be turned into effective manpower through
                appropriate training
                and management. Social awareness vis-a-vis ensuring rights can help make an inclusive society. Holistic
                endeavors are
                being undertaken by Proyash-Chattogram to educate children in special education settings, development of
                playing skills,
                arrangement of modern contemporary therapies, effective vocational schemes, etc. Consequently, these
                strategies can help
                them to be self-reliant. Proyash-Chattogram had been persevering towards provisioning these facilities,
                thereby making
                society aware of their needs and rights. <br> <br>
                The motivation and right-directional efforts of the respected Area Chief Patron, Assistant Patron and
                Chairman have
                accelerated the pace of the development of the Proyash-Chattogram. We are highly grateful to the people
                who have been
                working for the cause of the Proyash-Chattogram from the outset up to today. I am quite confident that
                with all your
                assistance, Proyash-Chattogram will progress steadily toward an inclusive and sustainable society.
              </p>
              <p>Jai Bangla, May Bangladesh live forever.</p>
              <br>
              <br>
              <p class="custom-bold">Lt Col Mohammad Mahbub Morshed, psc, infantry</p>
              <p>Principal, Proyash-Chattogram</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>